module.exports = __webpack_public_path__ + "img/xsfw_apxt.666c425f.png";